<div class="search-box">
  <input type="search" matInput [(ngModel)]="searchKey" placeholder="Search (Ctrl+K)" [attr.aria-label]="label" [title]="label + ' (Ctrl+K)'"
    role="combobox" aria-autocomplete="list" [attr.aria-expanded]="isOpen" aria-controls="search-results"
    [attr.aria-activedescendant]="activeIndex >= 0 ? optionId(activeIndex) : null"
    (click)="open($event)" (keyup)="open($event)" (keydown)="onKeydown($event)" #searchInput autocomplete="off">
</div>
<ng-template #searchOverlay>
  <div class="overlay-container" id="search-results" role="listbox" aria-label="Search results">
    @if (!searchKey.trim()) {
      <p class="search-hint">{{emptyHint}}</p>
    }
    @for (group of filteredGroups; track group.group + group.name) {
      <div class="group" role="group" [attr.aria-label]="group.name">
        <h4>{{group.name}}@if (group.current) {<span class="current">this project</span>}</h4>
        @for (result of group.results; track $index) {
          @let index = optionIndex(group, result);
          <div class="result" role="option" [id]="optionId(index)" [class.active]="index === activeIndex" [attr.aria-selected]="index === activeIndex"
            (click)="select(group, result)" (mouseenter)="activeIndex = index">
            <span class="icon">
              @if (result.type) {
                <app-node-svg [type]="result.type" [caller]="'Search: ' + result.name"></app-node-svg>
              }@else if (result.icon) {
                <mat-icon [fontIcon]="result.icon"></mat-icon>
              }
            </span>
            <span class="name">{{result.name}}</span>
            <span class="description">{{result.description}}</span>
          </div>
        }
        @if (group.more) {
          <p class="more">{{group.more}} more — keep typing to narrow the list</p>
        }
      </div>
    }@empty {
      <p class="empty">Nothing matches "{{searchKey}}".</p>
    }
  </div>
</ng-template>
